export const getBaseUrl = (program: string, cohort: string) => {
  switch (program) {
    case "odx":
      return "/founders";
    default:
      return `/programs/${program}/cohorts/${cohort}`;
  }
};

export const getStepUrl = (program: string, cohort: string, step?: string) =>
  `${getBaseUrl(program, cohort)}/steps/${step}`;

export const getReviewUrl = (program: string, cohort: string) => `${getBaseUrl(program, cohort)}/review`;

export const getSubmittedUrl = (program: string, cohort: string) => `${getBaseUrl(program, cohort)}/submitted`;
